import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { toUrl } from 'util/link';
import Head from 'next/head';

function AmpVimeoEmbed({ url }) {
  // extract vimeo ID from url
  const parsed = toUrl(url);
  const vimeoId = parsed.pathname.match(/([^/]+)\/?$/)[1];
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-vimeo"
          key="amp-vimeo-embed"
          src="https://cdn.ampproject.org/v0/amp-vimeo-0.1.js"
        />
      </Head>
      <amp-vimeo
        data-videoid={vimeoId}
        layout="responsive"
        width="16"
        height="9"
      />
    </Fragment>
  );
}

AmpVimeoEmbed.propTypes = {
  url: string
};

AmpVimeoEmbed.defaultProps = {
  url: undefined
};

export default AmpVimeoEmbed;
